import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  availableFilters: [],
  defaultFilterValues:{}
}
const filterSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setFiltersState: (state, action) => {
      const keys = Object.keys(action.payload)
      const filtersToAdd = []
      const availableFilters = state.availableFilters?.map(fil => fil.key)
      keys.forEach(key => {
        if(!availableFilters.includes(key) ) {
          filtersToAdd.push(action.payload[key])
        }
      })

      state.availableFilters = [...state.availableFilters, ...filtersToAdd];
    },
    setDefaultFilterValues: (_, action) => {
      return {
        defaultFilterValues: action.payload.defaultFilterValues, availableFilters: []
      }
    }
  },
});

export const { setFiltersState, setDefaultFilterValues } = filterSlice.actions;
export default filterSlice.reducer;
